import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 分销服务
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class DistributionService extends ServiceBase
{
    /**
     * 编辑/新增分销商品
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async opertionDistributionGoods(data: any): Promise<IHttpResponse>
    {
        let response;
        if(data.id)
        {
            response = await this.apis.updateDistributionGoods({
                data: data
            });
        }
        else
        {
            response = await this.apis.addDistributionGoods({
                data: data
            });
        }
        
        return response;
    }

    /**
     * 获取分销商品详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getDistributionGoodsDetail(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.getDistributionGoodsDetail({
            urlPath:{
                id
            }
        })
               
        return response;
    }

    
    /**
     * 分销商品列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getDistributionGoodsPage(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getDistributionGoodsPage({
            data: data
        })
               
        return response;
    }

    
    /**
     * 分销卖场商品列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getDistributionMarket(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getDistributionMarket({
            data: data
        })
               
        return response;
    }

    /**
     * 分销市场上下架
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async disGoodsOnOffshelf(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.disGoodsOnOffshelf({
           urlPath:{id}
        })
               
        return response;
    }

    /**
     * 获取分销市场详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getGoodsDistribution(id: string | number): Promise<IHttpResponse>
    {
        let response = await this.apis.getGoodsDistribution({
           urlPath:{id}
        })
               
        return response;
    }

    /**
     * 根据sku获取商品价格
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getDistGoodsPrice(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getDistGoodsPrice({
           data:data
        })
               
        return response;
    }

    
}